import { vt360Axios } from './axios';
import { ResponseTypes, TourResponseTypes } from '../types/response';
import { GET_TOUR_API } from '../commons/constants/apis';

export const getTourByCode = async (key: string): Promise<any> => {
  try {
    const { data }: ResponseTypes<TourResponseTypes> = await vt360Axios.get(
      `${GET_TOUR_API}/${key}`
    );

    return data;
  } catch (e) {
    return { notFound: true };
  }
};
